import { render, staticRenderFns } from "./CircRnaDifferentialExpression.vue?vue&type=template&id=52719b8c&scoped=true"
import script from "./CircRnaDifferentialExpression.vue?vue&type=script&lang=js"
export * from "./CircRnaDifferentialExpression.vue?vue&type=script&lang=js"
import style0 from "./CircRnaDifferentialExpression.vue?vue&type=style&index=0&id=52719b8c&prod&scoped=true&lang=css"
import style1 from "./CircRnaDifferentialExpression.vue?vue&type=style&index=1&id=52719b8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52719b8c",
  null
  
)

export default component.exports